import Tooltip from "components/Elements/Tooltip/Tooltip.js";
import React, { memo, useState, useRef, useEffect } from "react";
import { useDrag, useDrop } from "react-dnd";
import { ItemTypes } from "../Helper.js";
import FormBuilderCheckboxElement from "./FormBuilderCheckboxElement.js";
import FormBuilderRadioElement from "./FormBuilderRadioElement.js";
import FormBuilderSelectElement from "./FormBuilderSelectElement.js";
import parse from "html-react-parser";
import RecipienDropdownList from "../FormBuilderEditFields/FormBuilderRecipientElement/components/RecipintDropdownList.jsx";
import Icon from "components/Elements/Icon/Icon";

const style = {
  //border: "1px dashed gray",
  //padding: "0.5rem 1rem",
  //marginBottom: ".5rem",
  //backgroundColor: "white",
  //cursor: "move",
};

const FormBuilderElement = memo(function Card({
  id,
  moveCard,
  findCard,
  actionsContainer,
  buttonsColor,
  editFunction,
  activeField,
  item,
  index,
  setFormItems,
  formItems,
}) {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedRecipientPreviewName, setSelectedRecipientPreviewName] =
    useState("");

  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        !event.target.closest(".recipient-dropdown-content")
      ) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const originalIndex = findCard(id).index;
  const [{ isDragging }, drag] = useDrag(
    () => ({
      type: ItemTypes.ExistElement,
      item: { id, originalIndex },
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
      end: (item, monitor) => {
        const { id: droppedId, originalIndex } = item;
        const didDrop = monitor.didDrop();
        if (!didDrop) {
          moveCard(droppedId, originalIndex);
        }
      },
    }),
    [id, originalIndex, moveCard]
  );
  const [, drop] = useDrop(
    () => ({
      accept: ItemTypes.ExistElement,
      hover({ id: draggedId }) {
        if (draggedId !== id) {
          const { index: overIndex } = findCard(id);
          moveCard(draggedId, overIndex);
        }
      },
    }),
    [findCard, moveCard]
  );
  const opacity = isDragging ? 0 : 1;
  const tooltipIcon = (color) => {
    return (
      <svg
        className="tooltip-question"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="10" cy="10" r="9.5" stroke={color} />
        <path
          d="M9.44043 13.1973C9.44954 12.6549 9.51107 12.2266 9.625 11.9121C9.73893 11.5977 9.97135 11.249 10.3223 10.8662L11.2178 9.94336C11.6006 9.51042 11.792 9.04557 11.792 8.54883C11.792 8.07031 11.6667 7.69661 11.416 7.42773C11.1654 7.1543 10.8008 7.01758 10.3223 7.01758C9.85742 7.01758 9.48372 7.14062 9.20117 7.38672C8.91862 7.63281 8.77734 7.96322 8.77734 8.37793H7.5127C7.52181 7.63965 7.78385 7.04492 8.29883 6.59375C8.81836 6.13802 9.49284 5.91016 10.3223 5.91016C11.1836 5.91016 11.8535 6.14258 12.332 6.60742C12.8151 7.06771 13.0566 7.70117 13.0566 8.50781C13.0566 9.30534 12.6875 10.0915 11.9492 10.8662L11.2041 11.6045C10.8714 11.9736 10.7051 12.5046 10.7051 13.1973H9.44043ZM9.38574 15.3643C9.38574 15.1592 9.44727 14.9883 9.57031 14.8516C9.69792 14.7103 9.88477 14.6396 10.1309 14.6396C10.377 14.6396 10.5638 14.7103 10.6914 14.8516C10.819 14.9883 10.8828 15.1592 10.8828 15.3643C10.8828 15.5693 10.819 15.7402 10.6914 15.877C10.5638 16.0091 10.377 16.0752 10.1309 16.0752C9.88477 16.0752 9.69792 16.0091 9.57031 15.877C9.44727 15.7402 9.38574 15.5693 9.38574 15.3643Z"
          fill={color}
        />
      </svg>
    );
  };

  const handleDrop = (ev) => {
    ev.preventDefault();
    var data = ev.dataTransfer.getData("text");
  };

  const allowDrop = (ev) => {
    ev.preventDefault();
  };

  const handleLabelClick = (e) => {
    if (item.template === "recipientDropdown") {
      e.stopPropagation();
      setIsDropdownOpen(!isDropdownOpen);
    } else {
      editFunction(e, item);
    }
  };

  const titleField = (item) => {
    return (
      <div className="field-title">
        <span className="field-title-text">{item.fields.label}</span>
      </div>
    );
  };

  const textField = (item) => {
    return (
      <div className="field-text">
        <span className="field-text-text">{item.fields.label}</span>
      </div>
    );
  };

  const separatorField = (item) => {
    return (
      <div className="field-separator">
        <span className="field-separator-text"></span>
      </div>
    );
  };

  return (
    <div
      //onDrop={handleDrop}
      //onDragOver={allowDrop}
      onClick={(e) => {
        const isClickInsideDropdown = e.target.closest(
          ".recipient-dropdown-content-wrapper"
        );
        if (isClickInsideDropdown) {
          e.stopPropagation();
          return;
        }

        e.stopPropagation();
        if (item.template === "recipientDropdown") {
          setIsDropdownOpen(!isDropdownOpen);
        }
        editFunction(e, item);
      }}
      className={`field-item-container ${
        activeField === item.id ? "active" : ""
      } ${item.template === "speratorstatic" ? "separator" : ""}`}
      ref={(node) => drag(drop(node))}
      style={{ ...style, opacity }}
    >
      <div
        className={`field-item-content ${item.template}`}
        style={{ overflow: "hidden" }}
      >
        <div
          className="field-item-labelAndActions"
          style={{ overflow: "hidden" }}
        >
          <div
            className={`field-label ${
              item.template === "recipientDropdown"
                ? "recipient-field-label"
                : ""
            }`}
            ref={item.template === "recipientDropdown" ? dropdownRef : null}
            style={
              item.template === "recipientDropdown"
                ? { overflow: "hidden", flex: "1", minWidth: "0" }
                : {}
            }
          >
            <span
              className={`field-label-text ${
                item.template === "recipientDropdown"
                  ? "dropdown-label-text"
                  : ""
              }`}
              style={
                item.template === "recipientDropdown" &&
                selectedRecipientPreviewName
                  ? {
                      maxWidth: "100%",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      display: "block",
                    }
                  : {}
              }
            >
              {item.template !== "speratorstatic" &&
                (item.template === "recipientDropdown" &&
                selectedRecipientPreviewName
                  ? selectedRecipientPreviewName
                  : item.template === "textstatic"
                  ? parse(item.fields.label)
                  : item.fields.label)}
            </span>
            {item.fields.required ? (
              <span className="field-required">*</span>
            ) : null}
            {item.template === "recipientDropdown" &&
              item.fields?.recipients?.length > 0 && (
                <i
                  className={`fa fa-caret-down ${
                    !isDropdownOpen ? "is-closed-dropdown-arrow" : ""
                  }`}
                  aria-hidden="true"
                ></i>
              )}
          </div>
          {actionsContainer(item)}
        </div>
        {item.template === "recipientDropdown" && isDropdownOpen && (
          <RecipienDropdownList
            item={item}
            setIsDropdownOpen={setIsDropdownOpen}
            setFormItems={null}
            formItems={null}
            selectedRecipientPreviewName={selectedRecipientPreviewName}
            setSelectedRecipientPreviewName={setSelectedRecipientPreviewName}
          />
        )}
        {item.template === "multiplecheckboxes" && (
          <FormBuilderCheckboxElement
            field={item}
            buttonsColor={buttonsColor}
          />
        )}
        {item.template === "multipleradios" && (
          <FormBuilderRadioElement field={item} buttonsColor={buttonsColor} />
        )}
        {item.template === "selectbasic" && (
          <FormBuilderSelectElement field={item} />
        )}
      </div>
      {item.fields.helptext ? (
        <div
          className="field-tooltip"
          data-tip
          data-for={`field-${item.template}-${index}`}
        >
          {/* <div className="tooltip-text">
            <span>{item.fields.helptext}</span>
          </div> */}
          {/* {tooltipIcon(
            buttonsColor.includes("#") ? buttonsColor : "#" + buttonsColor
          )} */}
          {/* <Tooltip id={`field-${item.template}-${index}`} effect="solid">
            <span>{item.fields.helptext}</span>
          </Tooltip> */}
          <Tooltip
            id={`field-${item.template}-${index}`}
            tooltipText={item.fields.helptext}
            //hardPositioned
          >
            {tooltipIcon(
              buttonsColor.includes("#") ? buttonsColor : "#" + buttonsColor
            )}
          </Tooltip>
        </div>
      ) : null}
    </div>
  );
});

export default FormBuilderElement;
